import React from "react";
import {
  Grid,
  IconButton,
  Paper,
  Link
} from "@material-ui/core";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import actionsTopButtonStyles from '../../../../../components/App/customMaterialStyles';
import { Link as LinkRouter} from "react-router-dom";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../../../../redux/actions/ui";
import LessonsService from "../../../../../../services/LessonsService";
import { showConfirmDialog } from "../../../../../../redux/actions/uiConfirmDialog";

const useStyles = makeStyles(theme => ({
  root: {
    padding: "0 1.5em",
    borderTop: "1px solid #c8cccc",
    "& .lesson-title": {
      marginLeft: "1.5em"
    },
    "& .action-buttons button": {
      margin: "0.5em 0",
      marginLeft: "0.5em"
    },
    "& .a": {
      margin: "0.5em 0",
      marginLeft: "0.5em"
    }
  }
}));

function LessonItem(props) {
  const actionsTopButtonStylesClasses = actionsTopButtonStyles();
  const classes = useStyles();
  const { id, name } = props.data;
  const dispatch = useDispatch();

  const handleEdit = () => {
    props.setModalData(props.data);
    props.setOpenModalLessons(true);    
    props.setIsEditModal(true);
  }

  const handleOnDelete = async () => {    
    try{
      await LessonsService.deleteLesson(props.courseId, id);         
      dispatch(showSnackBar("Successfully Removed!"));
      props.fetchLessonsData();
    }catch (error) {
      console.log(error);
      // setIsLoadingSubmit(false);
    }  
  }

  const handleRemove = () => {
    dispatch(
      showConfirmDialog(
        "Remove this Lesson ?", 
        "You won't be able to revert this!", 
        handleOnDelete
      )
    );
  }

  return (
    <Paper  elevation={0} className={classes.root}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center">
          <div className="lesson-title">
            <Link
              component={LinkRouter}
              to={
                {
                  pathname: `/dashboard/syllabus/${props.courseId}/lesson/${id}/assignments`
                }
              }
              > 
                <h3>{name}</h3>
            </Link>
          </div>
          <div className="action-buttons">
            <IconButton className={clsx(actionsTopButtonStylesClasses.actionsTopButtons)} onClick={handleEdit}>
              <EditOutlinedIcon />
            </IconButton>  
            <IconButton className={clsx(actionsTopButtonStylesClasses.actionsTopButtons)} onClick={handleRemove}>
              <DeleteForeverOutlinedIcon />
            </IconButton>  
          </div>
      </Grid>     
    </Paper>
  )
}

export default LessonItem;